require('./sharebase-login.style');
export function LoginDirective() {
	return {
		restrict: 'E',
		controller: LoginController,
		controllerAs: 'vm',
		template: `<px-login title="{{vm.title}}">
			<header-icon>
				<div class="sb-login-icon"></div> 
			</header-icon>
		</px-login>`,
		bindToController: true,
		link: function (scope, element, attrs) {
		}
	};
}
function LoginController(gettextCatalog) {
	var vm = this;
	vm.title = gettextCatalog.getString('ShareBase');
}

LoginController.$inject = [
	'gettextCatalog'
];


// WEBPACK FOOTER //
// ./src/sharebase/components/login/sharebase-login.component.ts